export default __webpack_public_path__ + "static/media/Group 253.247b54c6.svg";